<template>
  <div id="body">
    <div v-if="mode === 'verifyEmail'">
      <div class style="margin-top: 36vh;textAlign: center;">
        <p
          class="card-message"
          :style="verifyEmail ? '' : 'color:red'"
        >{{verifyEmail ? 'Your Email is Verified' : message }}</p>
        <p style="font-size:24px; margin-top:2rem" v-if="verifyEmail">Page will redirect in 5 s</p>
      </div>
    </div>
    <div v-if="resetSuccess">
      <div style="margin-top: 36vh">
        <p class="card-message" style="textAlign: center; ">Password Reset Success</p>
      </div>
    </div>
    <div v-if="!resetSuccess && mode === 'resetPassword'">
      <div class="reset_password container">
        <h2>Reset Password</h2>
        <div class="mx-auto">
          <!-- body -->
          <form @submit.prevent="updatePassword">
            <label class="form-group pure-material-textfield-outlined">
              <input
                v-model="password"
                type="password"
                class="form-control"
                id="new_password"
                placeholder=" "
              />
              <span>New password</span>
              <p class="error-message">{{this.passwordMessage || "&nbsp;"}}</p>
            </label>
            <label class="form-group pure-material-textfield-outlined">
              <input
                v-model="confirmPassword"
                type="password"
                class="form-control"
                id="confirm_password"
                placeholder=" "
              />
              <span>Confirm new password</span>
              <p class="error-message">{{this.confirmPasswordMessage || "&nbsp;"}}</p>
              <p class="error-message">{{errorMessage || "&nbsp;"}}</p>
            </label>

            <div class="form-group">
              <button
                v-on:click="verificationSent = false"
                type="submit"
                class="btn color-btn btn-block"
                style="white-space: normal"
              >Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    PulseLoader
  },
  data() {
    return {
      verifyEmail: true,
      message: "",
      color: "white",
      size: "10px",
      loading: true,
      mode: "",

      password: "",
      passwordMessage: "",
      confirmPassword: "",
      confirmPasswordMessage: "",
      resetSuccess: false,

      errorMessage: "",

      //API key
      api_key: ""
    };
  },
  created() {
    const routeQuery = this.$route.query;
    console.log("[redirect-page] routeQuery is: ", this.$route);
    this.mode = routeQuery.mode;
    if (routeQuery.mode == "verifyEmail") {
      // Step 1: email should be verified
      this.$store
        .dispatch("verifyEmail", routeQuery)
        .then(message => {
          this.message = message.data.message + " page will redirect in 5 s";
          window.localStorage.setItem("token", routeQuery.token);
          window.localStorage.setItem(
            "expirationDate",
            new Date(Date.now() + 1000 * 3600 * 24 * 30) // 30 days
          );
          setTimeout(this.redirectToLogin, 5000);
        })
        .catch(err => {
          const { message, error } = err.response.data;
          this.verifyEmail = false;
          this.message = message;
        });
    } else if (routeQuery.mode == "resetPassword") {
      this.$data.verifyEmail = false;
      this.$data.loading = false;
    } else {
      console.log(routeQuery);
    }
  },
  methods: {
    redirectToLogin() {
      this.$router.replace("/signin");
    },

    updatePassword() {
      const vm = this;
      this.passwordMessage = "";
      this.confirmPasswordMessage = "";
      this.errorMessage = "";
      if (this.password.length < 10) {
        this.passwordMessage = "Password must have at least 10 characters";
      } else if (this.password !== this.confirmPassword) {
        this.confirmPasswordMessage = "Confirm password does not match";
      } else {
        this.$store
          .dispatch("updatePassword", {
            newPassword: this.password,
            token: this.$route.query.token
          })
          .then(message => {
            this.resetSuccess = true;
            setTimeout(this.redirectToLogin, 3000);
          })
          .catch(err => {
            console.log(err.response);
            this.errorMessage = err.response.data.message;
          });
      }
    }
  }
};
</script>

<style scoped>
* {
  font-family: Jura !important;
  font-weight: bold;
  color: #4a4a4a;
}

.sign-up-header {
  padding: 5%;
  background: white;
  /* min-height: 800px; */
  /* color: white; */
}

#body {
  background: url("../../assets/imgs/purewhite_curveline.png") no-repeat center
    fixed;
  background-size: cover;
  min-height: 100vh;
}

.loading_line {
  height: 3px;
  background-image: linear-gradient(90deg, transparent, transparent 100%),
    linear-gradient(90deg, #71d6d6, #2693c2);
  background-size: 20px 3px, 100% 3px;
  width: 70%;
  margin: 2rem auto;
  border: none;
}

.reset_password {
  margin-top: 25vh;
}

.card-message {
  font-size: 3rem;
  letter-spacing: 1.41px;
}

h2 {
  margin-top: 5%;
  margin: auto;
  padding: 1rem;
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  width: 450px;
}

.message {
  margin: 2rem auto;
  max-width: 450px;
}

.card {
  background-color: white !important;
  margin: 25px;
  padding: 30px 0;
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.21),
    0 5px 15px 0 rgba(0, 0, 0, 0.08);
  /* transition: all 0.5s; */
  width: 600px;
  float: none;
  border-radius: 15px;
}

.footer {
  text-align: center;
  font-style: italic;
}

.form-control {
  margin-bottom: 15px;
}

.error-message {
  font-size: 1rem;
  color: red;
}

.color-btn {
  color: black;
  background: #f5a623;
  font-weight: bold;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.47px;
  width: 60%;
  margin: 1rem auto;
  color: #ffffff;
}

.btn-info {
  font-weight: bold;
  width: 60%;
  margin: 1rem auto;
}

.form-check-label {
  margin-bottom: 10px;
  font-size: 80%;
}

.form-check {
  margin-top: -15px;
  margin-bottom: 10px;
}

.form-check-input {
  margin-left: 0px;
}

.form-check-label {
  margin-left: 0.5rem;
}

.login {
  margin-top: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
  border: none;
  color: #16abbd;
  cursor: pointer;
}

.pure-material-textfield-outlined {
  /* --pure-material-safari-helper1: rgb(var(--pure-material-primary-rgb, 33, 150, 243)); */
  position: relative;
  width: 60%;
  display: block;
  margin: 10px auto;
  padding-top: 6px;
  font-family: var(
    --pure-material-font,
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  font-size: 16px;
  line-height: 1.5;
  overflow: hidden;
}

/* Input, Textarea */
.pure-material-textfield-outlined > input {
  box-sizing: border-box;
  margin: 0;
  border: solid 1px; /* Safari */
  border-color: #bbbbbb;
  border-top-color: transparent;
  border-radius: 4px;
  width: 100%;
  height: inherit;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  background-color: transparent;
  box-shadow: none; /* Firefox */
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  transition: border 0.2s, box-shadow 0.2s;
}

/* Span */
.pure-material-textfield-outlined > input + span {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  border-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  width: 100%;
  max-height: 100%;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  font-size: 75%;
  line-height: 15px;
  cursor: text;
  transition: color 0.2s, font-size 0.2s, line-height 0.2s;
}

/* Corners */
.pure-material-textfield-outlined > input + span::before,
.pure-material-textfield-outlined > input + span::after {
  content: "";
  display: block;
  box-sizing: border-box;
  margin-top: 6px;
  border-top: solid 1px;
  border-top-color: #bbbbbb;
  min-width: 10px;
  height: 8px;
  pointer-events: none;
  box-shadow: inset 0 1px transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.pure-material-textfield-outlined > input + span::before {
  margin-right: 4px;
  border-left: solid 1px transparent;
  border-radius: 4px 0;
}

.pure-material-textfield-outlined > input + span::after {
  flex-grow: 1;
  margin-left: 4px;
  border-right: solid 1px transparent;
  border-radius: 0 4px;
}

/* Placeholder-shown */
.pure-material-textfield-outlined > input:not(:focus):placeholder-shown {
  border-top-color: #bbbbbb;
}

.pure-material-textfield-outlined > input:not(:focus):placeholder-shown + span {
  font-size: inherit;
  line-height: 50px;
}

.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input:not(:focus):placeholder-shown
  + span::after {
  border-top-color: transparent;
}

/* Focus */
.pure-material-textfield-outlined > input:focus {
  border-color: #16abbd;
  border-top-color: transparent;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input:focus + span {
  border-color: #16abbd;
}

.pure-material-textfield-outlined > input:focus + span::before,
.pure-material-textfield-outlined > input:focus + span::after {
  border-top-color: #16abbd !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* error */
.pure-material-textfield-outlined > input.error,
.pure-material-textfield-outlined > input.error + span {
  border-color: red !important;
  border-top-color: transparent !important;
}

.pure-material-textfield-outlined > input.error + span::before,
.pure-material-textfield-outlined > input.error + span::after {
  border-top-color: red !important;
}

.pure-material-textfield-outlined > input.error:placeholder-shown,
.pure-material-textfield-outlined > input.error:placeholder-shown + span {
  border-top-color: red !important;
}

.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::before,
.pure-material-textfield-outlined
  > input.error:placeholder-shown
  + span::after {
  border-top-color: transparent !important;
}

/* Error && Focus */
.pure-material-textfield-outlined > input.error:focus {
  border-color: red;
  border-top-color: transparent !important;
  box-shadow: inset 1px 0 var(--pure-material-safari-helper1),
    inset -1px 0 var(--pure-material-safari-helper1),
    inset 0 -1px var(--pure-material-safari-helper1);
  outline: none;
}

.pure-material-textfield-outlined > input.error:focus + span::before,
.pure-material-textfield-outlined > input.error:focus + span::after {
  border-top-color: red !important;
  box-shadow: inset 0 1px var(--pure-material-safari-helper1);
}

/* Faster transition in Safari for less noticable fractional font-size issue */
@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .pure-material-textfield-outlined > input,
    .pure-material-textfield-outlined > input + span,
    .pure-material-textfield-outlined > input + span::before,
    .pure-material-textfield-outlined > input + span::after {
      transition-duration: 0.1s;
    }
  }
}

@media screen and (max-width: 768px) {
  h2 {
    text-align: center;
    width: auto;
    font-size: 3rem;
  }
}

@media screen and (max-width: 500px) {
  .pure-material-textfield-outlined {
    font-size: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/static/redirect-page.vue